import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

// Import Roboto (used for body text)
//@ts-ignore
import "@fontsource/roboto/300.css";
//@ts-ignore
import "@fontsource/roboto/400.css";
//@ts-ignore
import "@fontsource/roboto/500.css";
//@ts-ignore
import "@fontsource/roboto/700.css";
// Import Oswald (if you are using it for headings)
//@ts-ignore
import "@fontsource/oswald/300.css";
//@ts-ignore
import "@fontsource/oswald/400.css";
//@ts-ignore
import "@fontsource/oswald/500.css";
//@ts-ignore
import "@fontsource/oswald/700.css";

//@ts-ignore
import "./index.css";
import App from "components/App/App";
import reportWebVitals from "./reportWebVitals";
import { store } from "redux/store";

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<App />
		</Provider>
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
